/**
 * @file Route: contacts
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "layouts/main";
import { globalData } from "@olmokit/core/data";
import { replaceFragment } from "@olmokit/core/fragments";
import { FormType } from "components/Form";
import { GMAP_API_KEY } from "config/index";
import mapStyle from "utils/mapstyle.json";
import "components/Title";
import { VisualPlus } from "components/VisualPlus"; 
import "components/Related";
import "./index.scss";

console.log("Route contacts/index.js mounted.");

replaceFragment("contactForm", "components.FormType").then(() => FormType());
// FormType();

VisualPlus();

const apiKey = GMAP_API_KEY;
const lang = globalData.gMapsLang;
 
const script = document.createElement("script");
script.setAttribute("async", "true");
script.setAttribute("defer", "true");
script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=contactsMap&language=${lang}`;
document.body.appendChild(script);

window.contactsMap = function contactsMap() {
    var ap = { lat: 44.5457003, lng: 10.8497364 };
    var map = new google.maps.Map(document.getElementById("contactsmap"), {
        zoom: 10,    
        zoomControl: false, 
        cameraControl: true, 
        mapTypeControl: false, 
        scaleControl: true,  
        streetViewControl: false, 
        rotateControl: true, 
        fullscreenControl: true,
        center: ap,
        styles: mapStyle,
    });
    var icon = {
        url: document.getElementById("mapMarker").value, // url
        scaledSize: new google.maps.Size(50, 50), // scaled size
        // origin: new google.maps.Point(0,0), // origin
        // anchor: new google.maps.Point(0, 0) // anchor
    };
    var marker = new google.maps.Marker({
        position: ap,
        map: map,
        icon: icon,
        title: "Atlas Plan",
    });
};
